<template>
  <pp-modal v-model="showModal" :mask-closable="false" width="1000">
    <p slot="header" class="modalHead">
      <span>修改账户信息</span>
    </p>
    <div class="modalContent">
      <pp-row>
        <pp-col :span="24">
          <pp-form :model="updateBankinfo" :rules="rules" ref="ruleForm" class="bankInfo-title" label-position="left" :label-width="140" inline>
            <pp-form-item label="账号币种:" class="bankInfo-item "  prop="currency">
              <pp-select v-model="updateBankinfo.currency" style="width:160px" >
                <pp-option
                  v-for="item in currencyList"
                  :value="item.value"
                  :key="item.value">
                  {{item.label}}
                </pp-option>
              </pp-select>
            </pp-form-item>
            <pp-line width="100%" class="bankInfo-line" style="margin:0 0 20px 0;"></pp-line>
            <pp-form-item label="企业名称:">
              <pp-input v-model="authentication" :disabled="true" placeholder="企业名称" style="width: 282px"></pp-input>
            </pp-form-item>
            <pp-form-item label="企业英文名称:">
              <pp-input v-model="companyEnglishName" :disabled="true" placeholder="企业英文名称" style="width: 282px"></pp-input>
            </pp-form-item>
            <pp-line width="100%" class="bankInfo-line" style="margin:0 0 20px 0;"></pp-line>
            <pp-form-item label="银行名称:" prop="bankName">
              <pp-input v-model.trim="updateBankinfo.bankName" placeholder="银行名称" :maxlength='255' style="width: 282px"></pp-input>
            </pp-form-item>
            <pp-form-item label="银行卡号:" prop="cardNo">
              <pp-input v-model.trim="updateBankinfo.cardNo"  placeholder="银行卡号" :maxlength='64' style="width: 282px"></pp-input>
            </pp-form-item>
            <pp-form-item label="支行名称（国内）:" prop="branchInfo">
              <pp-input v-model.trim="updateBankinfo.branchInfo" placeholder="支行名称" :maxlength='255' style="width: 282px"></pp-input>
            </pp-form-item>
            <pp-form-item label="银行代码"  prop="swiftCode">
                        <span slot="label" style="line-height:18px; margin-top:-12px;display:inline-block;">Swift代码:
                            <a style="display:block;" class="acla" href="https://www2.swift.com/bsl/index.faces" :maxlength='64' target="_blank">查询Swift Code</a>
                        </span>
              <pp-input v-model.trim="updateBankinfo.swiftCode" placeholder="Swift代码" :maxlength='64' style="width: 282px"></pp-input>
            </pp-form-item>
            <pp-form-item label="银行代码:" prop="bankCode">
              <pp-input v-model.trim="updateBankinfo.bankCode" placeholder="银行代码" :maxlength='64' style="width: 282px"></pp-input>
            </pp-form-item>
            <pp-form-item label="开户支行地址:" prop="bankAddress">
              <pp-input v-model.trim="updateBankinfo.bankAddress" placeholder="开户支行地址" :maxlength='255' style="width: 719px"></pp-input>
            </pp-form-item>
            <!-- <pp-form-item label="联系人:" prop="accountName">
                <pp-input v-model.trim="updateBankinfo.accountName" placeholder="联系人" :maxlength='64' style="width: 282px"></pp-input>
            </pp-form-item> -->
            <pp-form-item label="联系人手机号:" prop="reservedPhoneNo">
              <pp-input v-model.trim="updateBankinfo.reservedPhoneNo"   placeholder="联系人手机" :maxlength='64' style="width: 282px"></pp-input>
            </pp-form-item>
            <pp-line width="100%" class="bankInfo-line" style="margin:0 0 20px 0;"></pp-line>
            <pp-form-item label="绑定手机号:">
              <pp-input v-model="updateBankinfo.phoneNo"  :disabled="true" placeholder="绑定手机号" style="width: 282px"></pp-input>
            </pp-form-item>
            <pp-form-item label="安全验证码:" prop="verifyCode" class="verifycodebox">
              <pp-input v-model.trim="updateBankinfo.verifyCode" placeholder="安全验证码" style="width: 282px"></pp-input>
              <pp-button size="spec" class="codebox" @click="SetPhoneCode" :loading="codeState" >
                <span v-if="!codeState">获取验证码</span>
                <span v-else>{{codeTime2}}秒可重新发送</span>
              </pp-button>
            </pp-form-item>
          </pp-form>
        </pp-col>
      </pp-row>
    </div>
    <div slot="footer" style="text-align:right;">
      <pp-button size="spec"    @click="cancle()">取消</pp-button>
      <pp-button type="primary" size="spec" :loading="loading2"  @click="updatefun()">确认</pp-button>
    </div>
  </pp-modal>
</template>

<script>
  import {
    Component,
    Vue,
    Prop,
    Watch
  } from 'vue-property-decorator'
  import {
    createNamespacedHelpers
  } from 'vuex'
  import {
    Getter,
    Action,
    namespace
  } from 'vuex-class'
  const {
    mapGetters: webMapGetters,
    mapActions: webMapActions
  } = createNamespacedHelpers('user')
  export default {
    name: 'updateuserinfoModal',
    props: {
      // parms:{},
    },
    computed:{
      ...webMapGetters([
        'beneficiarySendMsgInfo',
        'updatebeneficiaryInfo'
      ])
    },
    mounted() {
      // this.updateBankinfo.bankName = this.parms.bank.bankName;
      // this.int(this.parms);
    },
    data() {
      return {
        codeState:false,
        loading2:false,
        showModal: false,
        authentication:'',
        companyEnglishName:'',
        codeTime2:'',
        updateBankinfo:{
          phoneNo:'',
          currency:'USD',
          verifyCode:'',
          clientId:'',
          accountName:'',
          reservedPhoneNo:'',
          bankName:'',
          branchInfo:'',
          cardNo:'',
          bankAddress:'',
          bankCode:'',
        },
        rules: {
          currency:[ { required: true, message: '请选择币种', trigger: 'change' }],
          bankName: [
            {required: true,
              trigger: 'blur',
              validator: (rule, value, callback) => {
                const ChineseReg = /[\u4e00-\u9fa5]/
                if (!value) {
                  callback(new Error('请填写中文银行名称'))
                  return false
                }
                const reg = ChineseReg.test(value)
                if (reg) {
                  callback()
                } else {
                  callback(new Error('请输入银行中文名称'))
                  return false
                }
              }
            }
          ],
          cardNo: [
            { required: true, message: '请填写提现账号', trigger: 'blur' }
          ],
          swiftCode: [
            { required: true, message: '请填写Swift代码', trigger: 'blur' }
          ],
          bankCode: [
            { required: true, message: '请填写银行代码', trigger: 'blur' }
          ],
          bankAddress: [
            { required: true, message: '请填写开户支行地址', trigger: 'blur' }
          ],
          accountName: [
            { required: true, message: '请填写联系人', trigger: 'blur' }
          ],
          reservedPhoneNo: [
            {required: true,
              trigger: 'blur',
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('请填写联系人手机'))
                  return false
                } else {
                  callback()
                }
                // const mobileReg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/
                // var reg = mobileReg.test(value)
                // if (reg) {
                //     callback()
                // } else {
                //     callback(new Error('手机号不符合规则'))
                //     return false
                // }
              }
            }
          ],
          verifyCode: [
            { required: true, message: '请填写安全验证码', trigger: 'blur' }
          ],
        },
        currencyList:[
          {
            value: 'USD',
            label: '美金(USD)'
          },
        ],

      }
    },
    methods: {
      ...webMapActions([
        // 'getAccountCenterInfo',
        'beneficiarySendMsg',
        'updatebeneficiary'
      ]),
      getAllAmount(){
        this.formCustom.confirmAmount = Number(this.amount);
      },
      show() {
        this.showModal = true
      },
      cancle() {
        this.showModal = false
      },
      updatefun () {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.updateForm()
          } else {
            return false;
          }
        })
      },
      int (parms) {
        this.authentication = parms.authentication
        this.companyEnglishName = parms.companyEnglishName
        this.updateBankinfo.clientId = parms.clientId
        this.updateBankinfo.bankName = parms.bank.bankName;
        this.updateBankinfo.branchInfo = parms.bank.branchInfo;
        this.updateBankinfo.cardNo = parms.bank.banknum;
        this.updateBankinfo.swiftCode = parms.bank.swiftCode;
        this.updateBankinfo.bankCode = parms.bank.bankCode;
        this.updateBankinfo.bankAddress = parms.bank.bankAddress;
        this.updateBankinfo.accountName = parms.bank.cardHolder;
        this.updateBankinfo.reservedPhoneNo = parms.bank.phoneNo;
        this.updateBankinfo.phoneNo = parms.mobile;

      },
      // async getData() {
      //     await this.getAccountCenterInfo()
      //     this.updateBankinfo = this.accountCenterInfo.bank;

      // },
      // 更新信息
      async updateForm () {
        let _this = this;
        await this.updatebeneficiary(this.updateBankinfo);
        if (this.updatebeneficiaryInfo.statusCode == 104) {
          this.$message.error('验证码错误！')
        } else if (this.updatebeneficiaryInfo.statusCode == 103) {
          this.$message.error('验证码失效！')
        } else if (this.updatebeneficiaryInfo.statusCode == 102) {
          this.$message.error('收益账号已存在！')
        } else if (this.updatebeneficiaryInfo.statusCode == 101) {
          this.$message.success('修改收益账号成功！');
          window.location.reload();
        }

      },
      // 获取验证码
      async SetPhoneCode () {
        this.codeState = true;
        let int = 30;
        let _this = this;
        let info = {
          mobileNum:this.updateBankinfo.phoneNo,
          type:4,
        }
        await this.beneficiarySendMsg(info)
        this.codeTime2 = int;

        let inv = self.setInterval(function(){
          if (_this.codeTime2 === 1) {
            window.clearInterval(inv)
            _this.codeState = false;
          } else {
            int--;
            _this.time(int)
          }
        },1000)

      },
      time(int) {
        this.codeTime2 = int;
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .pp-form-inline .pp-form-item{
    padding-left: 24px;
  }
  .acla:active{
    color: #1fa0e8;
  }
  .acla:visited {
    color: #1fa0e8;
  }
  .modalHead {
    color: #000;
    font-size: 20px;
    text-align: left
  }

  .modalContent {
    text-align: left;
    font-size: 14px;
  }

  .control-input{
    margin: 20px 0;
    width: 200px;
    span{
      display: block;
      float: left;
    }
  }
  .all{
    width: 200px;
    height: 76px;
    line-height: 76px;
    cursor: pointer;
  }
  .verifycodebox{
    position: relative;
    .codebox{
      background: #fff;
      border: none;
      position: absolute;
      right: 1px;
      top: 2px;
      font-size: 14px;
      color: #1fa0e8;
    }
  }
</style>
